import type { WorkflowAutomationTriggerType } from '../models/automation-api.models';

/** Contrato API — WorkflowAutomationTriggerType (número 1..7). */
const TRIGGER_TYPE_TO_API_INT: Record<
  | 'DailyAgenda'
  | 'CardCreated'
  | 'CardMovedToStage'
  | 'CardFieldUpdated'
  | 'ChecklistItemCompleted'
  | 'WorkflowFormSubmitted'
  | 'CardDueDateNear'
  | 'CardDueDateOverdue',
  number
> = {
  DailyAgenda: 9,
  CardCreated: 1,
  CardMovedToStage: 2,
  CardFieldUpdated: 3,
  ChecklistItemCompleted: 4,
  WorkflowFormSubmitted: 5,
  CardDueDateNear: 6,
  CardDueDateOverdue: 7,
};

const TRIGGER_INT_TO_TYPE: Record<number, WorkflowAutomationTriggerType> = {
  9: 'DailyAgenda',
  1: 'CardCreated',
  2: 'CardMovedToStage',
  3: 'CardFieldUpdated',
  4: 'ChecklistItemCompleted',
  5: 'WorkflowFormSubmitted',
  6: 'CardDueDateNear',
  7: 'CardDueDateOverdue',
};

const TRIGGER_TYPE_FROM_API_NORMALIZED: Record<string, WorkflowAutomationTriggerType> = {
  dailyagenda: 'DailyAgenda',
  cardcreated: 'CardCreated',
  cardmovedtostage: 'CardMovedToStage',
  cardfieldupdated: 'CardFieldUpdated',
  checklistitemcompleted: 'ChecklistItemCompleted',
  workflowformsubmitted: 'WorkflowFormSubmitted',
  cardduedatenear: 'CardDueDateNear',
  cardduedateoverdue: 'CardDueDateOverdue',
};

const KNOWN_PASCAL = new Set<string>([
  'DailyAgenda',
  'CardCreated',
  'CardMovedToStage',
  'CardFieldUpdated',
  'ChecklistItemCompleted',
  'WorkflowFormSubmitted',
  'CardDueDateNear',
  'CardDueDateOverdue',
]);

/**
 * Normaliza resposta da API (inteiro, camelCase, PascalCase) para o tipo interno.
 */
export function normalizeWorkflowAutomationTriggerTypeFromApi(raw: unknown): WorkflowAutomationTriggerType {
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    const mapped = TRIGGER_INT_TO_TYPE[Math.trunc(raw)];
    if (mapped) return mapped;
  }
  const s = typeof raw === 'string' ? raw.trim() : '';
  if (!s) return 'CardCreated';
  const compact = s.toLowerCase().replace(/_/g, '');
  const fromCamel = TRIGGER_TYPE_FROM_API_NORMALIZED[compact];
  if (fromCamel) return fromCamel;
  if (KNOWN_PASCAL.has(s)) return s as WorkflowAutomationTriggerType;
  return s as WorkflowAutomationTriggerType;
}

/** Valor numérico para POST/PUT (apenas gatilhos do contrato). */
export function workflowAutomationTriggerTypeToApiInt(
  type: WorkflowAutomationTriggerType
): number {
  const n = TRIGGER_TYPE_TO_API_INT[type as keyof typeof TRIGGER_TYPE_TO_API_INT];
  if (typeof n === 'number') return n;
  return 1;
}
